import React, { useState } from "react";
import { ArtLightbox } from "./ArtLightbox";
import { SoldMark } from "./ArtGallery";
import { parseArt } from "../lib/artwork";

const WRAP = { grid: "grid grid-cols-2 sm:grid-cols-3 gap-3", masonry: "columns-2 sm:columns-3 gap-3", single: "space-y-10" };

// Public teaser: a portfolio gallery of the artist's public pieces.
export const TeaserGallery = ({ section, mediaUrl, accent, footer, initialPiece }) => {
  const arts = section.items.filter((it) => it.type === "artwork" && it.media).map((it) => ({ ...it, src: mediaUrl(it.id) }));
  const [open, setOpen] = useState(() => { const i = arts.findIndex((it) => it.id === initialPiece); return i >= 0 ? i : null; });
  const layout = section.layout;
  return (
    <div data-testid="teaser-gallery" data-layout={layout}>
      <div className={WRAP[layout] || WRAP.grid}>
        {arts.map((it, i) => {
          const art = parseArt(it.body);
          return (
            <div key={it.id} className={layout === "masonry" ? "mb-3 break-inside-avoid" : ""} data-testid={`teaser-art-tile-${it.id}`}>
              <button type="button" onClick={() => setOpen(i)} className={`relative block w-full overflow-hidden bg-white/5 group focus:outline-none ${layout === "grid" ? "aspect-square" : ""}`} aria-label={`Open ${it.title || "artwork"}`}>
                <img src={it.src} alt={it.title || ""} loading="lazy" className={`w-full ${layout === "grid" ? "h-full object-cover" : "h-auto"} transition-transform duration-500 group-hover:scale-[1.02]`} />
                <SoldMark art={art} />
              </button>
              {it.title && <div className={`font-body text-white mt-1.5 ${layout === "single" ? "text-base" : "text-xs truncate"}`}>{it.title}</div>}
            </div>
          );
        })}
      </div>
      {open !== null && <ArtLightbox items={arts} index={open} accent={accent} onClose={() => setOpen(null)} footer={footer} />}
    </div>
  );
};
